import type { IContentItem, IContentItemsContainer } from '@kontent-ai/delivery-sdk'
import type {
  IRefreshMessageData,
  IUpdateMessageData
} from '@kontent-ai/smart-link/types/lib/IFrameCommunicatorTypes'
import { defineStore } from 'pinia'
import type { ApiResponse } from '~~/app/types/shared/ApiResponse'
import type { KontentPageRoute } from '~~/app/types/shared/KontentPageRoute'
import type { ContentItemDto } from '~~/app/types/shared/ContentItemDto'

interface PageState {
  page: IContentItem | null
  linkedItems: IContentItemsContainer
}

export const usePageStore = defineStore('page', {
  state: (): PageState => ({
    page: null,
    linkedItems: {} as IContentItemsContainer,
  }),
  actions: {
    async fetchData(itemId: string) {
      const { data } = await useFetch<ApiResponse<ContentItemDto<IContentItem>>>(`/api/page/${itemId}`, {
        deep: true
      })
      if (data.value?.data) {
        this.page = data.value.data.item
        this.linkedItems = data.value.data.linkedItems as IContentItemsContainer
      }
    },
    updateItemData(data: IUpdateMessageData) {
      if (!this.page) return
      const targetLinkedItem = this.linkedItems[data.item.codename]

      if (targetLinkedItem) {
        for (let i = 0; i < data.elements.length; i++) {
          const element = data.elements[i]!
          const type = element.type
          const newValue = element.data.value
          const propertyName = camelCasePropertyName(element.element.codename)
          if (type === 'text') {
            targetLinkedItem.elements[propertyName]!.value = newValue
          }
        }
      }
    },
    async refreshItemData(data: IRefreshMessageData) {
      // const itemId = this.page?.system.id
      // if (itemId) await this.fetchData(itemId)
    },

    async getPage(urlPath: string, itemId?: string | undefined) {
      if (itemId) {
        const response = await $fetch<ApiResponse<KontentPageRoute>>(`/api/page/info`, {
          query: { itemid: itemId}
        })
        if (response) {
          return response.data
        }
      }
      const response2 = await $fetch<ApiResponse<KontentPageRoute>>(
        `/api/page/info?path=${urlPath}`
      )
      if (response2) {
        return response2.data
      }
    }
  },
  getters: {
    getLinkedItem:
      (state) =>
      <T>(codename: string) => {
        return state.linkedItems?.[codename] as T
      },
    pageTitle: (state) => {
      if (!state.page) return ''
      return state.page.elements.title?.value || ''
    },
    pageId: (state) => {
      if (!state.page) return ''
      return state.page.system.id
    },
    getListAs:
      (state) =>
      <T>(codenames: string[] | undefined) => {
        if (codenames && codenames.length > 0) {
          return codenames.map((codename) => state.linkedItems?.[codename] as T).filter(x => x);
        }
        return []
      },
    
  }
})
